// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { Metadata } from "generated/mos/entity";
import { Language } from "generated/mos/i18n";
import { LinkableMediaValue, LinkablePlacementValue, LinkableStringValue } from "generated/mos/linkable";
import { MoodColor } from "generated/mos/org/getty/color";
import { Getty360Event } from "generated/mos/org/getty/integration";
import { Category, CategoryValues } from "generated/mos/org/getty/pointofinterest";
import { TranslatableLinkableStringValue, TranslatableMediaValue, TranslatableStringValue } from "generated/mos/translatable";
import { Codec, DecodeContext, RemoteObject, WebRPCError, decodeMOSPoint, decodeMessageRepeated, encodeMOSPoint, ensureScalar, stripTypePropertyDeep } from "generated/webrpc";
import { Point2D } from "helpers/geo";

// AudioSiteContent represents all of the Audio content for a particular Site
// 
// The reason this exists is to give sort order to tour categories.
export namespace AudioSiteContent {
  export type Ref = { readonly typename: 'mos.org.getty.audio.AudioSiteContent', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.audio.AudioSiteContent');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a AudioSiteContent`);
    return v;
  }
  export const refName = "mos.org.getty.audio.AudioSiteContent" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.AudioSiteContent', readonly id: string } | undefined,
    // Relationships
    readonly siteRef: { readonly typename: 'mos.structure.Site', readonly id: string } | undefined,
    readonly stopRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Stop', readonly id: string }>,
    readonly tourRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Tour', readonly id: string }>,
    // The sort order of this field will be used by VX apps for sort order
    readonly tourCategoryRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.TourCategory', readonly id: string }>,
    readonly wayfindingMapRef: { readonly typename: 'mos.org.getty.audio.WayfindingMap', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    siteRef: undefined,
    stopRefs: [],
    tourRefs: [],
    tourCategoryRefs: [],
    wayfindingMapRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.AudioSiteContent");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["siteRef"] = v["siteRef"];
      out["stopRefs"] = v["stopRefs"];
      out["tourRefs"] = v["tourRefs"];
      out["tourCategoryRefs"] = v["tourCategoryRefs"];
      out["wayfindingMapRef"] = v["wayfindingMapRef"];
      return out as any as Entity;
    }
  }();
}

export namespace CarouselItem {
  export type Ref = { readonly typename: 'mos.org.getty.audio.CarouselItem', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.audio.CarouselItem');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a CarouselItem`);
    return v;
  }
  export const refName = "mos.org.getty.audio.CarouselItem" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.CarouselItem', readonly id: string } | undefined,
    readonly value: CarouselItemValue.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    value: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["value"] = CarouselItemValue.codec.encode(v.value);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.CarouselItem");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["value"] = ctx.decode(CarouselItemValue.codec, v["value"], "value");
      return out as any as Entity;
    }
  }();
}

export namespace CarouselItemValue {
  export const refName = "mos.org.getty.audio.CarouselItemValue" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly item: CarouselItemValue.AudioItem.Entity | CarouselItemValue.ImageItem.Entity | CarouselItemValue.VideoItem.Entity | CarouselItemValue.HeroImageItem.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    item: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      {
        const uv: any = v.item;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.audio.CarouselItemValue.AudioItem") {
            obj["audioItem"] = CarouselItemValue.AudioItem.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.audio.CarouselItemValue.HeroImageItem") {
            obj["heroImageItem"] = CarouselItemValue.HeroImageItem.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.audio.CarouselItemValue.ImageItem") {
            obj["imageItem"] = CarouselItemValue.ImageItem.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.audio.CarouselItemValue.VideoItem") {
            obj["videoItem"] = CarouselItemValue.VideoItem.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.audio.CarouselItemValue.item");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.CarouselItemValue");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        if (v["audioItem"] !== undefined) {
          out["item"] = ctx.decode(CarouselItemValue.AudioItem.codec, v["audioItem"], "audioItem");
        }
        if (v["heroImageItem"] !== undefined) {
          out["item"] = ctx.decode(CarouselItemValue.HeroImageItem.codec, v["heroImageItem"], "heroImageItem");
        }
        if (v["imageItem"] !== undefined) {
          out["item"] = ctx.decode(CarouselItemValue.ImageItem.codec, v["imageItem"], "imageItem");
        }
        if (v["videoItem"] !== undefined) {
          out["item"] = ctx.decode(CarouselItemValue.VideoItem.codec, v["videoItem"], "videoItem");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace AudioItem {
    export const refName = "mos.org.getty.audio.CarouselItemValue.AudioItem" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly carouselImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
      readonly audio: TranslatableMediaValue.Entity | undefined,
    }
    export const defaults: Entity = {
      type: refName,
      carouselImageRef: undefined,
      audio: undefined,
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        return stripTypePropertyDeep(v);
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.CarouselItemValue.AudioItem");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["carouselImageRef"] = v["carouselImageRef"];
        out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
        return out as any as Entity;
      }
    }();
  }

  export namespace ImageItem {
    export const refName = "mos.org.getty.audio.CarouselItemValue.ImageItem" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly carouselImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
      readonly fullScreenImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
      readonly altText: TranslatableStringValue.Entity | undefined,
      readonly creditText: TranslatableLinkableStringValue.Entity | undefined,
      readonly publicImageTitle: TranslatableStringValue.Entity | undefined,
    }
    export const defaults: Entity = {
      type: refName,
      carouselImageRef: undefined,
      fullScreenImageRef: undefined,
      altText: undefined,
      creditText: undefined,
      publicImageTitle: undefined,
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const obj: RemoteObject = {};
        obj["carouselImageRef"] = v.carouselImageRef;
        obj["fullScreenImageRef"] = v.fullScreenImageRef;
        obj["altText"] = TranslatableStringValue.codec.encode(v.altText);
        obj["creditText"] = TranslatableLinkableStringValue.codec.encode(v.creditText);
        obj["publicImageTitle"] = TranslatableStringValue.codec.encode(v.publicImageTitle);
        return obj;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.CarouselItemValue.ImageItem");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["carouselImageRef"] = v["carouselImageRef"];
        out["fullScreenImageRef"] = v["fullScreenImageRef"];
        out["altText"] = ctx.decode(TranslatableStringValue.codec, v["altText"], "altText");
        out["creditText"] = ctx.decode(TranslatableLinkableStringValue.codec, v["creditText"], "creditText");
        out["publicImageTitle"] = ctx.decode(TranslatableStringValue.codec, v["publicImageTitle"], "publicImageTitle");
        return out as any as Entity;
      }
    }();
  }

  export namespace VideoItem {
    export const refName = "mos.org.getty.audio.CarouselItemValue.VideoItem" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly carouselImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
      readonly video: TranslatableMediaValue.Entity | undefined,
    }
    export const defaults: Entity = {
      type: refName,
      carouselImageRef: undefined,
      video: undefined,
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        return stripTypePropertyDeep(v);
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.CarouselItemValue.VideoItem");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["carouselImageRef"] = v["carouselImageRef"];
        out["video"] = ctx.decode(TranslatableMediaValue.codec, v["video"], "video");
        return out as any as Entity;
      }
    }();
  }

  export namespace HeroImageItem {
    export const refName = "mos.org.getty.audio.CarouselItemValue.HeroImageItem" as const;
    export type Entity = {
      readonly type: typeof refName,
    }
    export const defaults: Entity = {
      type: refName,
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.CarouselItemValue.HeroImageItem");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        return out as any as Entity;
      }
    }();
  }

}

export namespace EventPointOfInterest {
  export type Ref = { readonly typename: 'mos.org.getty.audio.EventPointOfInterest', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.audio.EventPointOfInterest');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a EventPointOfInterest`);
    return v;
  }
  export const refName = "mos.org.getty.audio.EventPointOfInterest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.EventPointOfInterest', readonly id: string } | undefined,
    readonly moodRef: { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string } | undefined,
    readonly event: Getty360Event.Entity | undefined,
    readonly audio: TranslatableMediaValue.Entity | undefined,
    readonly teaserText: TranslatableStringValue.Entity | undefined,
    readonly content: TranslatableStringValue.Entity | undefined,
    readonly additionalInfo: TranslatableStringValue.Entity | undefined,
    readonly deepDiveLabel: TranslatableStringValue.Entity | undefined,
    readonly deepDiveContextLabel: TranslatableStringValue.Entity | undefined,
    readonly deepDiveUrl: TranslatableStringValue.Entity | undefined,
    readonly placement: LinkablePlacementValue.Entity | undefined,
    readonly tags: string,
    readonly unifiedSortKey: number,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    moodRef: undefined,
    event: undefined,
    audio: undefined,
    teaserText: undefined,
    content: undefined,
    additionalInfo: undefined,
    deepDiveLabel: undefined,
    deepDiveContextLabel: undefined,
    deepDiveUrl: undefined,
    placement: undefined,
    tags: "",
    unifiedSortKey: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["moodRef"] = v.moodRef;
      obj["event"] = Getty360Event.codec.encode(v.event);
      obj["audio"] = TranslatableMediaValue.codec.encode(v.audio);
      obj["teaserText"] = TranslatableStringValue.codec.encode(v.teaserText);
      obj["content"] = TranslatableStringValue.codec.encode(v.content);
      obj["additionalInfo"] = TranslatableStringValue.codec.encode(v.additionalInfo);
      obj["deepDiveLabel"] = TranslatableStringValue.codec.encode(v.deepDiveLabel);
      obj["deepDiveContextLabel"] = TranslatableStringValue.codec.encode(v.deepDiveContextLabel);
      obj["deepDiveUrl"] = TranslatableStringValue.codec.encode(v.deepDiveUrl);
      obj["placement"] = LinkablePlacementValue.codec.encode(v.placement);
      obj["tags"] = v.tags;
      obj["unifiedSortKey"] = v.unifiedSortKey;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.EventPointOfInterest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["moodRef"] = v["moodRef"];
      out["event"] = ctx.decode(Getty360Event.codec, v["event"], "event");
      out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
      out["teaserText"] = ctx.decode(TranslatableStringValue.codec, v["teaserText"], "teaserText");
      out["content"] = ctx.decode(TranslatableStringValue.codec, v["content"], "content");
      out["additionalInfo"] = ctx.decode(TranslatableStringValue.codec, v["additionalInfo"], "additionalInfo");
      out["deepDiveLabel"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveLabel"], "deepDiveLabel");
      out["deepDiveContextLabel"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveContextLabel"], "deepDiveContextLabel");
      out["deepDiveUrl"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveUrl"], "deepDiveUrl");
      out["placement"] = ctx.decode(LinkablePlacementValue.codec, v["placement"], "placement");
      out["tags"] = ensureScalar(ctx, v["tags"], "string");
      out["unifiedSortKey"] = ensureScalar(ctx, v["unifiedSortKey"], "number");
      return out as any as Entity;
    }
  }();
}

export namespace GenericPointOfInterest {
  export type Ref = { readonly typename: 'mos.org.getty.audio.GenericPointOfInterest', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.audio.GenericPointOfInterest');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a GenericPointOfInterest`);
    return v;
  }
  export const refName = "mos.org.getty.audio.GenericPointOfInterest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.GenericPointOfInterest', readonly id: string } | undefined,
    readonly moodRef: { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string } | undefined,
    readonly audio: TranslatableMediaValue.Entity | undefined,
    readonly teaserText: TranslatableStringValue.Entity | undefined,
    readonly content: TranslatableStringValue.Entity | undefined,
    readonly additionalInfo: TranslatableStringValue.Entity | undefined,
    readonly deepDiveLabel: TranslatableStringValue.Entity | undefined,
    readonly deepDiveContextLabel: TranslatableStringValue.Entity | undefined,
    readonly deepDiveUrl: TranslatableStringValue.Entity | undefined,
    readonly placement: LinkablePlacementValue.Entity | undefined,
    readonly image: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly title: TranslatableStringValue.Entity | undefined,
    readonly creditText: TranslatableStringValue.Entity | undefined,
    readonly category: Category,
    readonly tags: string,
    readonly headerText: TranslatableStringValue.Entity | undefined,
    readonly unifiedSortKey: number,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    moodRef: undefined,
    audio: undefined,
    teaserText: undefined,
    content: undefined,
    additionalInfo: undefined,
    deepDiveLabel: undefined,
    deepDiveContextLabel: undefined,
    deepDiveUrl: undefined,
    placement: undefined,
    image: undefined,
    title: undefined,
    creditText: undefined,
    category: "UNSET",
    tags: "",
    headerText: undefined,
    unifiedSortKey: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["moodRef"] = v.moodRef;
      obj["audio"] = TranslatableMediaValue.codec.encode(v.audio);
      obj["teaserText"] = TranslatableStringValue.codec.encode(v.teaserText);
      obj["content"] = TranslatableStringValue.codec.encode(v.content);
      obj["additionalInfo"] = TranslatableStringValue.codec.encode(v.additionalInfo);
      obj["deepDiveLabel"] = TranslatableStringValue.codec.encode(v.deepDiveLabel);
      obj["deepDiveContextLabel"] = TranslatableStringValue.codec.encode(v.deepDiveContextLabel);
      obj["deepDiveUrl"] = TranslatableStringValue.codec.encode(v.deepDiveUrl);
      obj["placement"] = LinkablePlacementValue.codec.encode(v.placement);
      obj["image"] = v.image;
      obj["title"] = TranslatableStringValue.codec.encode(v.title);
      obj["creditText"] = TranslatableStringValue.codec.encode(v.creditText);
      obj["category"] = v.category;
      obj["tags"] = v.tags;
      obj["headerText"] = TranslatableStringValue.codec.encode(v.headerText);
      obj["unifiedSortKey"] = v.unifiedSortKey;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.GenericPointOfInterest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["moodRef"] = v["moodRef"];
      out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
      out["teaserText"] = ctx.decode(TranslatableStringValue.codec, v["teaserText"], "teaserText");
      out["content"] = ctx.decode(TranslatableStringValue.codec, v["content"], "content");
      out["additionalInfo"] = ctx.decode(TranslatableStringValue.codec, v["additionalInfo"], "additionalInfo");
      out["deepDiveLabel"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveLabel"], "deepDiveLabel");
      out["deepDiveContextLabel"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveContextLabel"], "deepDiveContextLabel");
      out["deepDiveUrl"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveUrl"], "deepDiveUrl");
      out["placement"] = ctx.decode(LinkablePlacementValue.codec, v["placement"], "placement");
      out["image"] = v["image"];
      out["title"] = ctx.decode(TranslatableStringValue.codec, v["title"], "title");
      out["creditText"] = ctx.decode(TranslatableStringValue.codec, v["creditText"], "creditText");
      {
        const ev = ensureScalar(ctx, v["category"], "string") || defaults["category"];
        if (!CategoryValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.point_of_interest.Category`);
        }
        out["category"] = ev as any;
      }
      out["tags"] = ensureScalar(ctx, v["tags"], "string");
      out["headerText"] = ctx.decode(TranslatableStringValue.codec, v["headerText"], "headerText");
      out["unifiedSortKey"] = ensureScalar(ctx, v["unifiedSortKey"], "number");
      return out as any as Entity;
    }
  }();
}

export namespace Mood {
  export type Ref = { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.audio.Mood');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a Mood`);
    return v;
  }
  export const refName = "mos.org.getty.audio.Mood" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string } | undefined,
    readonly metadata: Metadata.Entity | undefined,
    // Relationships
    readonly siteRef: { readonly typename: 'mos.structure.Site', readonly id: string } | undefined,
    // Attributes
    readonly name: TranslatableStringValue.Entity | undefined,
    readonly imageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly imageAltText: TranslatableStringValue.Entity | undefined,
    readonly description: TranslatableStringValue.Entity | undefined,
    readonly audio: TranslatableMediaValue.Entity | undefined,
    readonly color: MoodColor.Entity | undefined,
    readonly creditText: TranslatableStringValue.Entity | undefined,
    readonly key: string,
    readonly stopRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Stop', readonly id: string }>,
    readonly stopPointsOfInterestRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.StopPointOfInterest', readonly id: string }>,
    readonly eventPointsOfInterestRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.EventPointOfInterest', readonly id: string }>,
    readonly genericPointsOfInterestRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.GenericPointOfInterest', readonly id: string }>,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    metadata: undefined,
    siteRef: undefined,
    name: undefined,
    imageRef: undefined,
    imageAltText: undefined,
    description: undefined,
    audio: undefined,
    color: undefined,
    creditText: undefined,
    key: "",
    stopRefs: [],
    stopPointsOfInterestRefs: [],
    eventPointsOfInterestRefs: [],
    genericPointsOfInterestRefs: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["metadata"] = Metadata.codec.encode(v.metadata);
      obj["siteRef"] = v.siteRef;
      obj["name"] = TranslatableStringValue.codec.encode(v.name);
      obj["imageRef"] = v.imageRef;
      obj["imageAltText"] = TranslatableStringValue.codec.encode(v.imageAltText);
      obj["description"] = TranslatableStringValue.codec.encode(v.description);
      obj["audio"] = TranslatableMediaValue.codec.encode(v.audio);
      obj["color"] = MoodColor.codec.encode(v.color);
      obj["creditText"] = TranslatableStringValue.codec.encode(v.creditText);
      obj["key"] = v.key;
      obj["stopRefs"] = v.stopRefs;
      obj["stopPointsOfInterestRefs"] = v.stopPointsOfInterestRefs;
      obj["eventPointsOfInterestRefs"] = v.eventPointsOfInterestRefs;
      obj["genericPointsOfInterestRefs"] = v.genericPointsOfInterestRefs;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.Mood");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["metadata"] = ctx.decode(Metadata.codec, v["metadata"], "metadata");
      out["siteRef"] = v["siteRef"];
      out["name"] = ctx.decode(TranslatableStringValue.codec, v["name"], "name");
      out["imageRef"] = v["imageRef"];
      out["imageAltText"] = ctx.decode(TranslatableStringValue.codec, v["imageAltText"], "imageAltText");
      out["description"] = ctx.decode(TranslatableStringValue.codec, v["description"], "description");
      out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
      out["color"] = ctx.decode(MoodColor.codec, v["color"], "color");
      out["creditText"] = ctx.decode(TranslatableStringValue.codec, v["creditText"], "creditText");
      out["key"] = ensureScalar(ctx, v["key"], "string");
      out["stopRefs"] = v["stopRefs"];
      out["stopPointsOfInterestRefs"] = v["stopPointsOfInterestRefs"];
      out["eventPointsOfInterestRefs"] = v["eventPointsOfInterestRefs"];
      out["genericPointsOfInterestRefs"] = v["genericPointsOfInterestRefs"];
      return out as any as Entity;
    }
  }();
}

export namespace Stop {
  export type Ref = { readonly typename: 'mos.org.getty.audio.Stop', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.audio.Stop');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a Stop`);
    return v;
  }
  export const refName = "mos.org.getty.audio.Stop" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.Stop', readonly id: string } | undefined,
    readonly metadata: Metadata.Entity | undefined,
    // Relationships
    readonly basedOnRef: { readonly typename: 'mos.org.getty.integration_tms.TMSObject' | 'mos.poi.POI', readonly id: string } | undefined,
    // The Tours that this Stop appears in. Note that even if this list is empty, the
    // Stop will still appear, in Random Access Mode (until or unless we add the ability
    // to have stops _not_ appear in Random Access Mode).
    readonly tourRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Tour', readonly id: string }>,
    // The sort order of this field will be used by VX apps for display order
    readonly relatedStopRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Stop', readonly id: string }>,
    // Wall numbers are not guaranteed to be unique. While there will only be a single
    // _physical instance_ of each wall number at each Site, there may be multiple Stops
    // (e.g. content for different tours for a single artwork) that use the same wall number.
    readonly wallNumber: string,
    readonly title: TranslatableLinkableStringValue.Entity | undefined,
    readonly image: LinkableMediaValue.Entity | undefined,
    readonly audio: TranslatableMediaValue.Entity | undefined,
    // There SHOULD be at least one item in the carousel. The first item SHOULD be
    // an image.
    readonly carouselItemRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.CarouselItem', readonly id: string }>,
    // Stops are not positioned explicitly in the space, they are only placed within
    // a space. We are not providing true wayfinding at present.
    // 
    // XXX: We cannot provide all of the lower-resolution spatial refs because the
    // getty service is not a client of locate and cannot infer them.
    readonly placement: LinkablePlacementValue.Entity | undefined,
    readonly producedBy: TranslatableLinkableStringValue.Entity | undefined,
    readonly objectDescription: TranslatableLinkableStringValue.Entity | undefined,
    // These values relate to the first carousel item for the stop, derived from the stop hero image.
    readonly imageAltText: string,
    readonly imageCopyright: LinkableStringValue.Entity | undefined,
    readonly publicImageTitle: TranslatableStringValue.Entity | undefined,
    readonly objectCopyright: LinkableStringValue.Entity | undefined,
    readonly placeCreated: TranslatableLinkableStringValue.Entity | undefined,
    readonly dateCreated: TranslatableLinkableStringValue.Entity | undefined,
    readonly materials: TranslatableLinkableStringValue.Entity | undefined,
    readonly creditLine: TranslatableLinkableStringValue.Entity | undefined,
    // when linked this initialises to the primary_title, but can be authored independantly from the
    // stop title.
    readonly artworkName: TranslatableLinkableStringValue.Entity | undefined,
    readonly moodRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Mood', readonly id: string }>,
    readonly stopPointsOfInterestRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.StopPointOfInterest', readonly id: string }>,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    metadata: undefined,
    basedOnRef: undefined,
    tourRefs: [],
    relatedStopRefs: [],
    wallNumber: "",
    title: undefined,
    image: undefined,
    audio: undefined,
    carouselItemRefs: [],
    placement: undefined,
    producedBy: undefined,
    objectDescription: undefined,
    imageAltText: "",
    imageCopyright: undefined,
    publicImageTitle: undefined,
    objectCopyright: undefined,
    placeCreated: undefined,
    dateCreated: undefined,
    materials: undefined,
    creditLine: undefined,
    artworkName: undefined,
    moodRefs: [],
    stopPointsOfInterestRefs: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["metadata"] = Metadata.codec.encode(v.metadata);
      obj["basedOnRef"] = v.basedOnRef;
      obj["tourRefs"] = v.tourRefs;
      obj["relatedStopRefs"] = v.relatedStopRefs;
      obj["wallNumber"] = v.wallNumber;
      obj["title"] = TranslatableLinkableStringValue.codec.encode(v.title);
      obj["image"] = LinkableMediaValue.codec.encode(v.image);
      obj["audio"] = TranslatableMediaValue.codec.encode(v.audio);
      obj["carouselItemRefs"] = v.carouselItemRefs;
      obj["placement"] = LinkablePlacementValue.codec.encode(v.placement);
      obj["producedBy"] = TranslatableLinkableStringValue.codec.encode(v.producedBy);
      obj["objectDescription"] = TranslatableLinkableStringValue.codec.encode(v.objectDescription);
      obj["imageAltText"] = v.imageAltText;
      obj["imageCopyright"] = LinkableStringValue.codec.encode(v.imageCopyright);
      obj["publicImageTitle"] = TranslatableStringValue.codec.encode(v.publicImageTitle);
      obj["objectCopyright"] = LinkableStringValue.codec.encode(v.objectCopyright);
      obj["placeCreated"] = TranslatableLinkableStringValue.codec.encode(v.placeCreated);
      obj["dateCreated"] = TranslatableLinkableStringValue.codec.encode(v.dateCreated);
      obj["materials"] = TranslatableLinkableStringValue.codec.encode(v.materials);
      obj["creditLine"] = TranslatableLinkableStringValue.codec.encode(v.creditLine);
      obj["artworkName"] = TranslatableLinkableStringValue.codec.encode(v.artworkName);
      obj["moodRefs"] = v.moodRefs;
      obj["stopPointsOfInterestRefs"] = v.stopPointsOfInterestRefs;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.Stop");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["metadata"] = ctx.decode(Metadata.codec, v["metadata"], "metadata");
      out["basedOnRef"] = v["basedOnRef"];
      out["tourRefs"] = v["tourRefs"];
      out["relatedStopRefs"] = v["relatedStopRefs"];
      out["wallNumber"] = ensureScalar(ctx, v["wallNumber"], "string");
      out["title"] = ctx.decode(TranslatableLinkableStringValue.codec, v["title"], "title");
      out["image"] = ctx.decode(LinkableMediaValue.codec, v["image"], "image");
      out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
      out["carouselItemRefs"] = v["carouselItemRefs"];
      out["placement"] = ctx.decode(LinkablePlacementValue.codec, v["placement"], "placement");
      out["producedBy"] = ctx.decode(TranslatableLinkableStringValue.codec, v["producedBy"], "producedBy");
      out["objectDescription"] = ctx.decode(TranslatableLinkableStringValue.codec, v["objectDescription"], "objectDescription");
      out["imageAltText"] = ensureScalar(ctx, v["imageAltText"], "string");
      out["imageCopyright"] = ctx.decode(LinkableStringValue.codec, v["imageCopyright"], "imageCopyright");
      out["publicImageTitle"] = ctx.decode(TranslatableStringValue.codec, v["publicImageTitle"], "publicImageTitle");
      out["objectCopyright"] = ctx.decode(LinkableStringValue.codec, v["objectCopyright"], "objectCopyright");
      out["placeCreated"] = ctx.decode(TranslatableLinkableStringValue.codec, v["placeCreated"], "placeCreated");
      out["dateCreated"] = ctx.decode(TranslatableLinkableStringValue.codec, v["dateCreated"], "dateCreated");
      out["materials"] = ctx.decode(TranslatableLinkableStringValue.codec, v["materials"], "materials");
      out["creditLine"] = ctx.decode(TranslatableLinkableStringValue.codec, v["creditLine"], "creditLine");
      out["artworkName"] = ctx.decode(TranslatableLinkableStringValue.codec, v["artworkName"], "artworkName");
      out["moodRefs"] = v["moodRefs"];
      out["stopPointsOfInterestRefs"] = v["stopPointsOfInterestRefs"];
      return out as any as Entity;
    }
  }();
}

export namespace StopPointOfInterest {
  export type Ref = { readonly typename: 'mos.org.getty.audio.StopPointOfInterest', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.audio.StopPointOfInterest');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a StopPointOfInterest`);
    return v;
  }
  export const refName = "mos.org.getty.audio.StopPointOfInterest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.StopPointOfInterest', readonly id: string } | undefined,
    readonly moodRef: { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string } | undefined,
    readonly stop: Stop.Entity | undefined,
    readonly audio: TranslatableMediaValue.Entity | undefined,
    readonly teaserText: TranslatableStringValue.Entity | undefined,
    readonly content: TranslatableStringValue.Entity | undefined,
    readonly additionalInfo: TranslatableStringValue.Entity | undefined,
    readonly deepDiveLabel: TranslatableStringValue.Entity | undefined,
    readonly deepDiveContextLabel: TranslatableStringValue.Entity | undefined,
    readonly deepDiveUrl: TranslatableStringValue.Entity | undefined,
    readonly tags: string,
    readonly headerText: TranslatableStringValue.Entity | undefined,
    readonly unifiedSortKey: number,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    moodRef: undefined,
    stop: undefined,
    audio: undefined,
    teaserText: undefined,
    content: undefined,
    additionalInfo: undefined,
    deepDiveLabel: undefined,
    deepDiveContextLabel: undefined,
    deepDiveUrl: undefined,
    tags: "",
    headerText: undefined,
    unifiedSortKey: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["moodRef"] = v.moodRef;
      obj["stop"] = Stop.codec.encode(v.stop);
      obj["audio"] = TranslatableMediaValue.codec.encode(v.audio);
      obj["teaserText"] = TranslatableStringValue.codec.encode(v.teaserText);
      obj["content"] = TranslatableStringValue.codec.encode(v.content);
      obj["additionalInfo"] = TranslatableStringValue.codec.encode(v.additionalInfo);
      obj["deepDiveLabel"] = TranslatableStringValue.codec.encode(v.deepDiveLabel);
      obj["deepDiveContextLabel"] = TranslatableStringValue.codec.encode(v.deepDiveContextLabel);
      obj["deepDiveUrl"] = TranslatableStringValue.codec.encode(v.deepDiveUrl);
      obj["tags"] = v.tags;
      obj["headerText"] = TranslatableStringValue.codec.encode(v.headerText);
      obj["unifiedSortKey"] = v.unifiedSortKey;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.StopPointOfInterest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["moodRef"] = v["moodRef"];
      out["stop"] = ctx.decode(Stop.codec, v["stop"], "stop");
      out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
      out["teaserText"] = ctx.decode(TranslatableStringValue.codec, v["teaserText"], "teaserText");
      out["content"] = ctx.decode(TranslatableStringValue.codec, v["content"], "content");
      out["additionalInfo"] = ctx.decode(TranslatableStringValue.codec, v["additionalInfo"], "additionalInfo");
      out["deepDiveLabel"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveLabel"], "deepDiveLabel");
      out["deepDiveContextLabel"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveContextLabel"], "deepDiveContextLabel");
      out["deepDiveUrl"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveUrl"], "deepDiveUrl");
      out["tags"] = ensureScalar(ctx, v["tags"], "string");
      out["headerText"] = ctx.decode(TranslatableStringValue.codec, v["headerText"], "headerText");
      out["unifiedSortKey"] = ensureScalar(ctx, v["unifiedSortKey"], "number");
      return out as any as Entity;
    }
  }();
}

export namespace Tour {
  export type Ref = { readonly typename: 'mos.org.getty.audio.Tour', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.audio.Tour');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a Tour`);
    return v;
  }
  export const refName = "mos.org.getty.audio.Tour" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.Tour', readonly id: string } | undefined,
    readonly metadata: Metadata.Entity | undefined,
    // Relationships
    readonly siteRef: { readonly typename: 'mos.structure.Site', readonly id: string } | undefined,
    // The sort order of this field will be used by VX apps for display order
    readonly stopRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Stop', readonly id: string }>,
    // Attributes
    readonly name: TranslatableStringValue.Entity | undefined,
    readonly imageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly imageAltText: TranslatableStringValue.Entity | undefined,
    readonly webpageUrl: TranslatableStringValue.Entity | undefined,
    readonly description: TranslatableStringValue.Entity | undefined,
    // <duration_minutes> is specified as an integer (not a duration or a string) since:
    // - it's a user entered field (it includes an estimate of the travel time between stops)
    // - it may be localised into different languages on the VX client, e.g.
    // 32 => "32 minutes" (in en-US)
    // 32 => "32分钟" (in zh-Hans)
    readonly durationMinutes: number,
    // Tour does not have a 'based_on' relationship with any other entities, so this can't
    // be a Linkable field; it requires a human to manually enter/edit.
    readonly creditText: TranslatableStringValue.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    metadata: undefined,
    siteRef: undefined,
    stopRefs: [],
    name: undefined,
    imageRef: undefined,
    imageAltText: undefined,
    webpageUrl: undefined,
    description: undefined,
    durationMinutes: 0,
    creditText: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["metadata"] = Metadata.codec.encode(v.metadata);
      obj["siteRef"] = v.siteRef;
      obj["stopRefs"] = v.stopRefs;
      obj["name"] = TranslatableStringValue.codec.encode(v.name);
      obj["imageRef"] = v.imageRef;
      obj["imageAltText"] = TranslatableStringValue.codec.encode(v.imageAltText);
      obj["webpageUrl"] = TranslatableStringValue.codec.encode(v.webpageUrl);
      obj["description"] = TranslatableStringValue.codec.encode(v.description);
      obj["durationMinutes"] = v.durationMinutes;
      obj["creditText"] = TranslatableStringValue.codec.encode(v.creditText);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.Tour");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["metadata"] = ctx.decode(Metadata.codec, v["metadata"], "metadata");
      out["siteRef"] = v["siteRef"];
      out["stopRefs"] = v["stopRefs"];
      out["name"] = ctx.decode(TranslatableStringValue.codec, v["name"], "name");
      out["imageRef"] = v["imageRef"];
      out["imageAltText"] = ctx.decode(TranslatableStringValue.codec, v["imageAltText"], "imageAltText");
      out["webpageUrl"] = ctx.decode(TranslatableStringValue.codec, v["webpageUrl"], "webpageUrl");
      out["description"] = ctx.decode(TranslatableStringValue.codec, v["description"], "description");
      out["durationMinutes"] = ensureScalar(ctx, v["durationMinutes"], "number");
      out["creditText"] = ctx.decode(TranslatableStringValue.codec, v["creditText"], "creditText");
      return out as any as Entity;
    }
  }();
}

export namespace TourCategory {
  export type Ref = { readonly typename: 'mos.org.getty.audio.TourCategory', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.audio.TourCategory');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a TourCategory`);
    return v;
  }
  export const refName = "mos.org.getty.audio.TourCategory" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.TourCategory', readonly id: string } | undefined,
    readonly metadata: Metadata.Entity | undefined,
    // Relationships
    readonly siteRef: { readonly typename: 'mos.structure.Site', readonly id: string } | undefined,
    // The sort order of this field will be used by VX apps for display order
    readonly tourRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Tour', readonly id: string }>,
    // Attributes
    readonly name: TranslatableStringValue.Entity | undefined,
    // <supported_languages> is used by the VX app to work out which categories to show.
    // If <supported_languages> is nil/empty, the VX app will show the category regardless
    // of the user's language preference. If it's non-nil, it will only show the category
    // if the user's language is included in <supported_languages>
    readonly supportedLanguages: ReadonlyArray<Language.Entity>,
    // Determines the order within a site_ref. These do not need to be consecutive
    // numbers, just sequential.
    readonly siteOrder: number,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    metadata: undefined,
    siteRef: undefined,
    tourRefs: [],
    name: undefined,
    supportedLanguages: [],
    siteOrder: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["metadata"] = Metadata.codec.encode(v.metadata);
      obj["siteRef"] = v.siteRef;
      obj["tourRefs"] = v.tourRefs;
      obj["name"] = TranslatableStringValue.codec.encode(v.name);
      obj["supportedLanguages"] = [];
      for (const item of v.supportedLanguages) {
        obj["supportedLanguages"].push(Language.codec.encode(item));
      }
      obj["siteOrder"] = v.siteOrder;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.TourCategory");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["metadata"] = ctx.decode(Metadata.codec, v["metadata"], "metadata");
      out["siteRef"] = v["siteRef"];
      out["tourRefs"] = v["tourRefs"];
      out["name"] = ctx.decode(TranslatableStringValue.codec, v["name"], "name");
      out["supportedLanguages"] = decodeMessageRepeated(ctx, Language.codec, v["supportedLanguages"], "supportedLanguages");
      out["siteOrder"] = ensureScalar(ctx, v["siteOrder"], "number");
      return out as any as Entity;
    }
  }();
}

export namespace VisitorType {
  export type Ref = { readonly typename: 'mos.org.getty.audio.VisitorType', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.audio.VisitorType');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a VisitorType`);
    return v;
  }
  export const refName = "mos.org.getty.audio.VisitorType" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.VisitorType', readonly id: string } | undefined,
    readonly label: TranslatableStringValue.Entity | undefined,
    readonly tag: string,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    label: undefined,
    tag: "",
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.VisitorType");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["label"] = ctx.decode(TranslatableStringValue.codec, v["label"], "label");
      out["tag"] = ensureScalar(ctx, v["tag"], "string");
      return out as any as Entity;
    }
  }();
}

// WayfindingMap is retrieved/managed via AudioSiteContent, not via its own RPCs
export namespace WayfindingMap {
  export type Ref = { readonly typename: 'mos.org.getty.audio.WayfindingMap', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.audio.WayfindingMap');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a WayfindingMap`);
    return v;
  }
  export const refName = "mos.org.getty.audio.WayfindingMap" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.WayfindingMap', readonly id: string } | undefined,
    readonly mapPdf: TranslatableMediaValue.Entity | undefined,
    // Accessibility description for the map, presented to screen readers as a substitute for the map content.
    readonly altText: TranslatableStringValue.Entity | undefined,
    readonly levels: ReadonlyArray<WayfindingMap.Level.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    mapPdf: undefined,
    altText: undefined,
    levels: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["mapPdf"] = TranslatableMediaValue.codec.encode(v.mapPdf);
      obj["altText"] = TranslatableStringValue.codec.encode(v.altText);
      obj["levels"] = [];
      for (const item of v.levels) {
        obj["levels"].push(WayfindingMap.Level.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.WayfindingMap");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["mapPdf"] = ctx.decode(TranslatableMediaValue.codec, v["mapPdf"], "mapPdf");
      out["altText"] = ctx.decode(TranslatableStringValue.codec, v["altText"], "altText");
      out["levels"] = decodeMessageRepeated(ctx, WayfindingMap.Level.codec, v["levels"], "levels");
      return out as any as Entity;
    }
  }();
  export namespace AnchorPoint {
    export const refName = "mos.org.getty.audio.WayfindingMap.AnchorPoint" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly geo: Point2D | undefined,
      readonly pdfX: number,
      readonly pdfY: number,
    }
    export const defaults: Entity = {
      type: refName,
      geo: undefined,
      pdfX: 0,
      pdfY: 0,
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const obj: RemoteObject = {};
        obj["geo"] = encodeMOSPoint(v.geo);
        obj["pdfX"] = v.pdfX;
        obj["pdfY"] = v.pdfY;
        return obj;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.WayfindingMap.AnchorPoint");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["geo"] = decodeMOSPoint(ctx, v["geo"]);
        out["pdfX"] = ensureScalar(ctx, v["pdfX"], "number");
        out["pdfY"] = ensureScalar(ctx, v["pdfY"], "number");
        return out as any as Entity;
      }
    }();
  }

  export namespace Level {
    export const refName = "mos.org.getty.audio.WayfindingMap.Level" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly levelRefs: ReadonlyArray<{ readonly typename: 'mos.structure.BuildingLevel' | 'mos.structure.OutdoorLevel', readonly id: string }>,
      readonly pdfPage: number,
      readonly topLeft: WayfindingMap.AnchorPoint.Entity | undefined,
      readonly bottomRight: WayfindingMap.AnchorPoint.Entity | undefined,
      readonly title: TranslatableStringValue.Entity | undefined,
      readonly abbreviation: string,
      readonly coordTransformString: string,
      readonly helmertX0: number,
      readonly helmertY0: number,
      readonly helmertS: number,
      readonly helmertTheta: number,
    }
    export const defaults: Entity = {
      type: refName,
      levelRefs: [],
      pdfPage: 0,
      topLeft: undefined,
      bottomRight: undefined,
      title: undefined,
      abbreviation: "",
      coordTransformString: "",
      helmertX0: 0,
      helmertY0: 0,
      helmertS: 0,
      helmertTheta: 0,
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const obj: RemoteObject = {};
        obj["levelRefs"] = v.levelRefs;
        obj["pdfPage"] = v.pdfPage;
        obj["topLeft"] = WayfindingMap.AnchorPoint.codec.encode(v.topLeft);
        obj["bottomRight"] = WayfindingMap.AnchorPoint.codec.encode(v.bottomRight);
        obj["title"] = TranslatableStringValue.codec.encode(v.title);
        obj["abbreviation"] = v.abbreviation;
        obj["coordTransformString"] = v.coordTransformString;
        obj["helmertX0"] = v.helmertX0;
        obj["helmertY0"] = v.helmertY0;
        obj["helmertS"] = v.helmertS;
        obj["helmertTheta"] = v.helmertTheta;
        return obj;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio.WayfindingMap.Level");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["levelRefs"] = v["levelRefs"];
        out["pdfPage"] = ensureScalar(ctx, v["pdfPage"], "number");
        out["topLeft"] = ctx.decode(WayfindingMap.AnchorPoint.codec, v["topLeft"], "topLeft");
        out["bottomRight"] = ctx.decode(WayfindingMap.AnchorPoint.codec, v["bottomRight"], "bottomRight");
        out["title"] = ctx.decode(TranslatableStringValue.codec, v["title"], "title");
        out["abbreviation"] = ensureScalar(ctx, v["abbreviation"], "string");
        out["coordTransformString"] = ensureScalar(ctx, v["coordTransformString"], "string");
        out["helmertX0"] = ensureScalar(ctx, v["helmertX0"], "number");
        out["helmertY0"] = ensureScalar(ctx, v["helmertY0"], "number");
        out["helmertS"] = ensureScalar(ctx, v["helmertS"], "number");
        out["helmertTheta"] = ensureScalar(ctx, v["helmertTheta"], "number");
        return out as any as Entity;
      }
    }();
  }

}

